import { useState } from 'react'

export const useChunkedList = <T>(items: T[], chunkSize: number) => {
  const [chunks, setChunks] = useState({ items, count: chunkSize })
  const visibleCount = chunks.items === items ? chunks.count : chunkSize

  return {
    visibleItems: items.slice(0, visibleCount),
    hasMore: visibleCount < items.length,
    showMore: () =>
      setChunks({
        items,
        count: Math.min(visibleCount + chunkSize, items.length),
      }),
  }
}
